import {getDynContextValueText} from '@packages/systems/dynamo/utils/ParamPanelUtils';
import type {ParamPanelUIProps} from './types';
import type {ConsolidatedBindingContext} from '@packages/systems/dynamo/gateway';

export function getSelectedItemRefOptionLabel({
  fieldType,
  value,
  bindingContext,
  availableItemRefOptions,
}: {
  fieldType: string;
  value: string;
  bindingContext: ConsolidatedBindingContext | null;
  availableItemRefOptions: ParamPanelUIProps['availableItemRefOptions'];
}) {
  const isReferenceField =
    fieldType === 'ItemRef' || fieldType === 'ItemRefSet';
  const hasNoValue = !value || typeof value !== 'string';

  if (!isReferenceField || hasNoValue) {
    return '';
  }

  const option = availableItemRefOptions.find((opt) => opt.value === value);

  if (option) {
    return option.label;
  }

  return getDynContextValueText(value, bindingContext) || 'Deleted Item';
}
